import React from 'react';
import { Box, List, ListItem, Button,useColorModeValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const NavigationDrawer = () => {
  const textColor = useColorModeValue('black', 'white'); 
  const navigate = useNavigate();  // Instantiate the useNavigate hook
  
  return (
    <Box>
      <List spacing={3}>
        <ListItem>
          <Button variant="ghost" onClick={() => navigate('/home')} color={textColor}>
            Home
          </Button>
        </ListItem>
        <ListItem>
          <Button variant="ghost" onClick={() => navigate('/nemt-provider-dashboard')} color={textColor}>
            Nemt Provider Dashboard
          </Button>
        </ListItem>
        <ListItem>
          <Button variant="ghost" onClick={() => navigate('/credentialing-dashboard')} color={textColor}>
            Credentialing Dashboard
          </Button>
        </ListItem>
        <ListItem>
          <Button variant="ghost" onClick={() => navigate('/mr-nemt-dashboard')} color={textColor}>
            Mileage Reimbursement Dashboard
          </Button>
        </ListItem>
        {/* Add more navigation items as needed */}
      </List>
    </Box>
  );
};

export default NavigationDrawer;
